import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '@/lib/supabase-config';

const SUPABASE_PUBLISHABLE_KEY = SUPABASE_ANON_KEY;

/**
 * Singleton Supabase client — the ONLY GoTrueClient instance in the app.
 * All files must import from this module: import { supabase } from "@/integrations/supabase/client";
 */
let supabaseInstance: SupabaseClient<Database> | null = null;

function getSupabaseClient(): SupabaseClient<Database> {
  if (!supabaseInstance) {
    supabaseInstance = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'reprev-auth',
        storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      },
    });
  }
  return supabaseInstance;
}

export const supabase = getSupabaseClient();